// ╭────────────────────────────────────────────────────────────────────────────────────╮
// ┊  This file was automatically generated
// ┊  Please do not modify manually
// ┊  ©gl it 2026 - http://www.gl-it.ch
// ╰────────────────────────────────────────────────────────────────────────────────────╯

/* eslint-disable quote-props */

import DataRecord, { unwrapDataRecord } from '@glittr/frontend-core/src/core/v2/data/data-record';
import ServiceModelBase from '@glittr/frontend-core/src/core/v2/data/service-model-base';
import DeepPartial from '@glittr/frontend-core/src/core/v2/utility-types/deep-partial';
import AnalyticsCompanyItemPagingResultModel from '../../model/analytics-company-item-paging-result-model';
import AnalyticsCompanyItemPagingResultDTO from '../dto/analytics-company-item-paging-result-dto';
import dtoSchema from '../schemas/analytics-company-item-paging-result-schema';
import AnalyticsCompanyItemModel from '../../model/analytics-company-item-model';
import ResourceLinkModel from '../../model/resource-link-model';
import PaginationDataModel from '../../model/pagination-data-model';

export default abstract class AnalyticsCompanyItemPagingResultModelBase extends ServiceModelBase {
  constructor(data?: DeepPartial<AnalyticsCompanyItemPagingResultDTO>) {
    super();
    if (data) {
      this.items = data.items?.map((i) => AnalyticsCompanyItemModel.toModel(i)) ?? [];
      this.links = data.links?.map((i) => ResourceLinkModel.toModel(i)) ?? [];
      this.paginationData = data.paginationData ? PaginationDataModel.toModel(data.paginationData) : undefined;
    }
  }
  /**
  */
  items?: AnalyticsCompanyItemModel[];
  /**
  */
  links?: ResourceLinkModel[];
  /**
  */
  paginationData?: PaginationDataModel;

  static toModel(dto: DeepPartial<AnalyticsCompanyItemPagingResultDTO>): AnalyticsCompanyItemPagingResultModel;
  static toModel(dto: DeepPartial<AnalyticsCompanyItemPagingResultDTO> | undefined | null): AnalyticsCompanyItemPagingResultModel | undefined;
  static toModel(dto: DeepPartial<AnalyticsCompanyItemPagingResultDTO> | undefined | null): AnalyticsCompanyItemPagingResultModel | undefined {
    return dto ? new AnalyticsCompanyItemPagingResultModel(dto) : undefined;
  }
  static toDTO(model: DataRecord<AnalyticsCompanyItemPagingResultModel> | AnalyticsCompanyItemPagingResultModel): AnalyticsCompanyItemPagingResultDTO {
    const unwrapped = unwrapDataRecord(model);
    const dto = {
      items: unwrapped.items,
      links: unwrapped.links,
      paginationData: unwrapped.paginationData,
    } as AnalyticsCompanyItemPagingResultDTO;
    const errors = ServiceModelBase.validator.validate(dtoSchema, dto);
    if (errors.length > 0) {
      throw new Error(`Invalid data for AnalyticsCompanyItemPagingResultModel, can not map to AnalyticsCompanyItemPagingResultDTO: ${errors.map((e) => `${e?.propName}: ${e?.message}`).join(', ')}`);
    }
    return dto;
  }

  validate(): boolean {
    const dtoErrors = this.getValidationErrors(dtoSchema);
    const modelErrors = this.getValidationErrors(this.schema ?? {});
    this.errors = [...dtoErrors, ...modelErrors];
    return this.errors.length === 0;
  }
}
